import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { RatingChoices } from '../../../utils/constants';
import TennisRating from './TennisRating';
import PickleballRating from './PickleballRating';
import ColorballRating from './ColorballRating';

import styles from './ratingDisplayV5.scss';

const RatingDisplayV5 = (props) => {
    const {
        isProProfile,
        profileData,
        ratingClassName,
        isOwnProfile,
        onTennisGetRatedClick,
        onPickleballGetRatedClick,
        doNotMask = false,
        'data-testid': dataTestId,
    } = props;

    const auth = useSelector(({ auth }) => auth);
    const userLoggedIn = auth?.user;
    const { showPickleballRating, showTennisRating, ratingChoice } = profileData;

    const getRatingToDisplay = () => {
        if (ratingChoice === RatingChoices.PROGRESSION_BALL_RATING) {
            return (
                <ColorballRating
                    profileData={profileData}
                    isOwnProfile={isOwnProfile}
                    data-testid={dataTestId ? `${dataTestId}.colorball` : undefined}
                />
            );
        }
        return (
            <>
                {showTennisRating && (
                    <TennisRating
                        auth={auth}
                        profileData={profileData}
                        isOwnProfile={isOwnProfile}
                        onTennisGetRatedClick={onTennisGetRatedClick}
                        doNotMask={doNotMask}
                        data-testid={dataTestId ? `${dataTestId}.tennis` : undefined}
                    />
                )}
                {showPickleballRating && (
                    <PickleballRating
                        profileData={profileData}
                        isOwnProfile={isOwnProfile}
                        onPickleballGetRatedClick={onPickleballGetRatedClick}
                        data-testid={dataTestId ? `${dataTestId}.pickleball` : undefined}
                    />
                )}
            </>
        );
    };

    return (
        <div className={`${styles.ratingDisplay} ${ratingClassName || ''} updated`} data-testid={dataTestId}>
            <div className={`${styles.utrContainer} ${!userLoggedIn && !isProProfile ? styles.blur : ''}`} data-testid={dataTestId ? `${dataTestId}.utr-container` : undefined}>
                {getRatingToDisplay()}
            </div>
            {!userLoggedIn && !isProProfile && (
                <div
                    className={`${styles.signUpToView} btn btn-primary text-uppercase`}
                    onClick={props.handleSignInClick}
                    data-testid={dataTestId ? `${dataTestId}.sign-in-btn` : undefined}
                >
                    Sign In to View Rating
                </div>
            )}
        </div>
    );
};

RatingDisplayV5.defaultProps = {
    isOwnProfile: false,
    isProProfile: false,
    ratingClassName: '',
    doNotMask: false,
};

RatingDisplayV5.propTypes = {
    profileData: PropTypes.instanceOf(Object).isRequired,
    isOwnProfile: PropTypes.bool,
    onPickleballGetRatedClick: PropTypes.func.isRequired,
    isProProfile: PropTypes.bool,
    ratingClassName: PropTypes.string,
    onTennisGetRatedClick: PropTypes.func.isRequired,
    doNotMask: PropTypes.bool,
};

export default RatingDisplayV5;
